import React, {useContext } from "react";
import { PJContext } from "./pj-context"
import {supFractions} from "../helpers";
import CONSTS from "./pj-constants";
import axios from "axios";



function PJOrderSummaryBar(props) {
    const { state, dispatch, data, animateToCheckout } = useContext(PJContext);

    function validatePurchase() {
        dispatch({type:CONSTS.DATA_LOADING, loading:true});

        let formData = {

        };
        console.log('state.selectedAddons', state.selectedAddons);
        if (state.selectedAddons !== undefined &&
            typeof state.selectedAddons === 'object' &&
            Object.keys(state.selectedAddons).length !== 0) {
            formData.addons = Object.keys(state.selectedAddons).map((addon) => {console.log("Addon", state.selectedAddons[addon].id); return state.selectedAddons[addon].id.toString()}); //get array of addon ids
            console.log(formData.addons);
        }

        console.log('state.standaloneSelected', state.standaloneSelected);
        if (state.standaloneSelected !== undefined &&
            typeof state.standaloneSelected === 'object' &&
            Object.keys(state.standaloneSelected).length !== 0) {
            formData.standalone = Object.keys(state.standaloneSelected).map((id) => id);  //get array of ids
        }

        if (state.seasonTickets) {
            formData.seasonTickets = 1;
        }


        console.log('formData', formData);
        axios.post('/purchase/validate', formData)
            .then(function (response) {
                // console.log(response);
                switch (response.data.status) {
                    case 'OK':
                        animateToCheckout();
                        break;
                    case 'ERROR':
                        //DF: Display purchase validation errors
                        break;
                }
            })
            .catch(function (error) {
                //DF: Disply purchase validation errors
            })
            .then(() => { //ALWAYS
                dispatch({type:CONSTS.DATA_LOADING, loading:false});
            })
        ;
    }
    return  (
        <div className="order-summary">
            <div className="container">
                <div className="row">
                    <div className="col-sm-2 col-xs-5 order-sm-0 order-xs-1 my-auto">
                        <div className="go-back-button wp-block-button aligncenter is-style-outline">
                            <button className="wp-block-button__link has-text-color has-light-red-color arrow-back" onClick={e => dispatch({ type: CONSTS.CLOSE_JOURNEY}) }>Go back</button>
                        </div>
                    </div>

                    <div className="col-sm-8 order-sm-1 order-xs-0 col-xs-12 my-auto">
                        <div className="order-price flex-fill d-flex align-items-center">
                            <p className="cost-info d-flex mx-auto">
                                <span className="heading my-auto"><span>Your <strong>REV</strong> Order</span></span>
                                <span className="regular-price-amount my-auto" dangerouslySetInnerHTML={{__html: supFractions(state.monthlyTotal)}} />
                                <span className="monthly-cost align-self-end my-auto">monthly cost &nbsp;&nbsp; {(state.seasonTotal > 0) && '+'}</span>
                                {state.seasonTotal > 0 &&
                                    <>
                                        <span className="regular-price-amount my-auto" dangerouslySetInnerHTML={{__html: supFractions(state.seasonTotal)}} />
                                        <span className="monthly-cost align-self-end my-auto">season cost</span>
                                    </>
                                }
                                <span className="vat-info">* prices exclude VAT</span>
                            </p>
                        </div>
                    </div>

                    <div className="col-sm-2 col-xs-5 order-xs-2 flex-xs-fill my-auto ml-xs-auto">
                        <div className="continue-button wp-block-button aligncenter is-style-outline has-white-background-color">
                            <button onClick={e => validatePurchase()} className="wp-block-button__link has-text-color has-light-red-color has-white-background-color">Continue</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export { PJOrderSummaryBar };